import createAxiosInstance from './axiosConfig';

// INTERFACES
export interface SerasaCadastroResponse {
  id: string;
  cpf: string;
  rank: number | null;
  result: string;
  additionalInformation: string[];
}

export interface SerasaConsultaRequest {
  cpfcnpj: string;
  dataCadastroINI?: string;
  dataCadastroFIM?: string;
  protocoloBrFlow?: string;
}

export interface SerasaConsultaResponseItem {
  cpfcnpj: string;
  contrato: string;
  DataCadastro: string;
  DataConclusao: string;
  StatusRegistro: string;
  ResultadoAnalise: string;
  ProtocoloBrFlow: string;
}

// CLASSE DE SERVIÇO

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(`${REACT_APP_ESTEIRA_BACK}/rest/serasa`);

export default class SerasaService {
  axios: typeof axiosInstance;

  constructor() {
    this.axios = axiosInstance;
  }

  async cadastrarRegistro(cpf: string, files: File[]): Promise<SerasaCadastroResponse> {
    try {
      const formData = new FormData();
      
      formData.append('cpf', cpf);

      files.forEach((file) => {
        formData.append('document', file);
      });

      const response = await this.axios.post<SerasaCadastroResponse>('/enviarDocumento', formData);
      return response.data;
    } catch (error) {
      console.error('Erro ao cadastrar registro no SerasaService:', error);
      throw error;
    }
  }

  async consultarRegistro(requestBody: SerasaConsultaRequest): Promise<SerasaConsultaResponseItem[]> {
    try {
      const response = await this.axios.post<SerasaConsultaResponseItem[]>('/consultarRegistros', requestBody);
      return response.data;
    } catch (error) {
      console.error('Erro ao consultar registro no SerasaService:', error);
      throw error;
    }
  }
}